/* eslint-disable react/jsx-wrap-multilines */

import React from 'react'
import { Box, Text } from 'grommet'
import GamesIcon from './icons/GamesIcon'

class Avatar extends React.Component {
  
  // <Avatar
  //   title='Philippe'
  //   subtitle='G.'
  //   iconName='GiFigurehead'
  //   color='red'
  // />

  render() {

    const title = this.props.title
    const subtitle = this.props.subtitle
    const color = this.props.color
    const backgroundColor = this.props.backgroundColor
    let name = 'GiFigurehead'
    if (this.props.iconName) name= this.props.iconName //'GiFigurehead'

    return(
      <Box direction='row' align='center' gap='small' style={{minWidth:'200px', minHeight:'100px'}}>
        <GamesIcon name={name} color={color} backgroundColor={backgroundColor} />
        <Box justify='between'>
          <Text truncate={false}>{title}</Text>
          <Text size='small' truncate={true}>{subtitle}</Text>
        </Box>
      </Box>
    )
  }
}

export default Avatar

//style={{minWidth:'200px'}}

//</Box>{React.createElement(gamesIcon, 
      //</Box>  {
      //</Box>    color:'blue', 
      //</Box>    style: 
      //</Box>    {
      //</Box>      width:'80px',
      //</Box>      height:'80px',
      //</Box>      backgroundColor: color,
      //</Box>      display: 'flex',
      //</Box>      alignItems: 'center',
      //</Box>      justifyContent: 'space-around',
      //</Box>      padding: '10px',
      //</Box>      borderRadius: '50%',
      //</Box>      boxSizing: 'border-box',
      //</Box>    }
      //</Box>  }
      //</Box>)}
  
